/**
 * PermissionRoute Component
 * Wraps a route and redirects to first accessible page if user lacks permission
 */
import { ReactNode } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { RedirectToFirstAccessible } from './RedirectToFirstAccessible';

interface PermissionRouteProps {
  permission: string;
  children: ReactNode;
}

export const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const { hasPermission, isSuperUser } = usePermissions();

  // SuperUsers bypass all permission checks
  if (isSuperUser()) {
    return <>{children}</>;
  }

  // Check if user has required permission
  if (hasPermission(permission)) {
    return <>{children}</>;
  }

  // User doesn't have permission - redirect to first accessible page
  return <RedirectToFirstAccessible />;
};

export default PermissionRoute;

